module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _c('main', [_vm._t("default")], 2), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3259699a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/ModalFaker.vue
// module id = 940
// module chunks = 0